export default __webpack_public_path__ + "static/media/standsExpo_prysmian.e6ffb07e.jpg";